import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsSoftwareProformaJiraFormBuilderRoute } from '@jira/router-routes__project-settings-product-routes-software-routes/src/projectSettingsSoftwareProformaJiraFormBuilderRoute.tsx';
import { softwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { getSettingsNavigationResources } from './ui/project-settings/product-routes/common/index.tsx';
import ProformaJiraFormBuilder, {
	LazyProjectSettingsProformaJiraFormBuilder,
} from './ui/project-settings/proforma-jira-form-builder/index.tsx';

export const projectSettingsSoftwareProformaJiraFormBuilderRouteEntry: Route = createEntry(
	projectSettingsSoftwareProformaJiraFormBuilderRoute,
	() => ({
		group: 'project-settings-software',
		// eslint-disable-next-line no-restricted-syntax
		component: ProformaJiraFormBuilder,
		layout: softwareProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getSettingsNavigationResources()],
		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsProformaJiraFormBuilder],
		perfMetricKey: 'form-builder',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
